require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./nuisance-intervention-team.json") })
        }
      }, "path---nuisance-intervention-team");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---nuisance-intervention-team!./.cache/json/nuisance-intervention-team.json
// module id = 943
// module chunks = 231608221292675